import { getDocLink } from '@utils/links';
const { GLOBAL_INFO = {} } = window;

export const getPublicHost = () => GLOBAL_INFO.publicHost || getDocLink().PUBLIC_WUJI_DOMAIN || '';

export const isRuntime = () => GLOBAL_INFO.mode === 'runtime';
